import { DEFAULT_LOCALE, detectBrowserLocale, isSupportedLocale } from "./locales";

export const LOCALE_STORAGE_KEY = "dropchance.locale";
export const LOCALE_MANUAL_KEY = "dropchance.locale.manual";

/** Coerce any value to a supported locale, defaulting to English. */
export function ensureValidLocale(locale) {
  return isSupportedLocale(locale) ? locale : DEFAULT_LOCALE;
}

function normalizeLocale(locale) {
  return ensureValidLocale(locale);
}

function readStoredLocale(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || !isSupportedLocale(raw)) {
      if (raw != null) {
        localStorage.removeItem(key);
      }
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}

/** Save locale; set userChoice when the user picks a language in the footer. */
export function saveLocalePreference(locale, { userChoice = false } = {}) {
  try {
    const normalized = normalizeLocale(locale);
    localStorage.setItem(LOCALE_STORAGE_KEY, normalized);

    if (userChoice) {
      localStorage.setItem(LOCALE_MANUAL_KEY, normalized);
    }
  } catch {
    // Storage blocked (private mode, quota, etc.) — in-memory route still works.
  }
}

/** Locale for "/" auto-redirect; invalid stored values fall back to browser, then English. */
export function readPreferredLocaleForRedirect() {
  const manual = readStoredLocale(LOCALE_MANUAL_KEY);
  if (manual) {
    return manual;
  }

  const stored = readStoredLocale(LOCALE_STORAGE_KEY);
  if (stored && stored !== DEFAULT_LOCALE) {
    return stored;
  }

  return ensureValidLocale(detectBrowserLocale());
}
